export const categories = [
  { id: "original", name: "原创作品", slug: "yuanchuang", description: "奶妈动漫原创插画、漫画与短篇故事", icon: "ri-paint-brush-line", count: 15 },
  { id: "character", name: "角色设定", slug: "jiaose", description: "哺育题材动漫角色档案与设定集", icon: "ri-user-heart-line", count: 12 },
  { id: "fanart", name: "同人创作", slug: "tongren", description: "粉丝二次创作与同人作品精选", icon: "ri-heart-pulse-line", count: 18 },
  { id: "knowledge", name: "育儿科普", slug: "yuer", description: "母乳哺育知识与动漫科普结合", icon: "ri-book-read-line", count: 10 },
  { id: "recommend", name: "动漫推荐", slug: "tuijian", description: "温情治愈系动漫推荐与赏析", icon: "ri-star-smile-line", count: 14 },
  { id: "story", name: "治愈故事", slug: "zhiyu", description: "温暖人心的哺育题材小故事", icon: "ri-emotion-happy-line", count: 9 },
];

export const articles = [
  {
    id: 1,
    title: "《星之子》——当哺乳成为拯救世界的力量",
    slug: "star-child-breastfeeding-power",
    category: "original",
    excerpt: "在这部原创漫画中，主角小暖是一位拥有特殊母乳能量的年轻母亲。她的乳汁不仅能滋养自己的孩子，更能为陷入黑暗的星球带来光明与希望。",
    content: `
      <h2>故事背景</h2>
      <p>在遥远的未来，人类文明已经遍布银河系。然而，一场名为"暗蚀"的灾难正在吞噬一颗又一颗星球。这种黑暗能量会让所有生命失去活力，逐渐凋零。</p>
      <p>科学家们发现，唯一能够对抗"暗蚀"的，是一种被称为"生命之光"的特殊能量——而这种能量，只存在于哺乳期母亲的母乳之中。</p>

      <h2>主角登场</h2>
      <p>小暖，26岁，一位普通的年轻母亲。她原本只是在一颗边境星球上安静地抚养着自己刚满六个月的孩子，直到某天，一支星际救援队找到了她。</p>
      <p>经过检测，小暖体内的"生命之光"浓度是常人的数百倍。她的乳汁拥有极其强大的治愈能力和生命能量，足以点亮一整颗濒死的星球。</p>

      <h2>矛盾与抉择</h2>
      <p>面对拯救无数生命的责任，小暖陷入了深深的矛盾。她需要离开自己的孩子，前往危机四伏的前线。但她也知道，如果不这么做，会有更多的孩子失去母亲，更多的家庭支离破碎。</p>
      <p>"妈妈要去帮助其他小朋友了，"小暖轻轻吻了吻怀中熟睡的婴儿，"你要乖乖等妈妈回来。"</p>

      <h2>治愈之旅</h2>
      <p>《星之子》不仅仅是关于拯救世界的冒险故事，更是一部关于母爱力量的赞歌。每一场战斗、每一次治愈，都让小暖更加深刻地理解了作为母亲的意义。</p>
      <p>她遇到了一位失去孩子的外星母亲，用自己温暖的怀抱治愈了对方心中的伤痛；她帮助了一颗因为战争而失去所有新生儿的小行星，让那里的母亲们重新燃起希望。</p>

      <h2>创作理念</h2>
      <p>我们希望通过这部作品，让更多人看到母乳哺育背后的力量与美。母乳不仅仅是营养的来源，更是母爱最直接的传递方式。每一位哺乳的母亲，都是孩子生命中的英雄。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20warm%20and%20healing%20anime%20illustration%20of%20a%20young%20mother%20holding%20her%20baby%20under%20a%20starry%20night%20sky%2C%20soft%20golden%20light%20surrounding%20them%2C%20gentle%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20anime%20art%20style%20with%20flowing%20hair%20and%20twinkling%20stars%2C%20clean%20composition%20on%20soft%20cream%20background&width=800&height=450&seq=article-star-child&orientation=landscape",
    author: "暖阳工作室",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20icon%20of%20a%20warm%20sun%20with%20gentle%20smile%2C%20soft%20orange%20and%20yellow%20tones%2C%20simple%20flat%20design%2C%20minimalist%20illustration%20on%20light%20background&width=100&height=100&seq=avatar-warm-studio&orientation=squarish",
    date: "2026-08-01",
    readTime: "8分钟",
    tags: ["原创漫画", "科幻", "母爱", "治愈"],
    featured: true,
  },
  {
    id: 2,
    title: "角色档案：樱田葵——温柔而强大的哺乳妈妈战士",
    slug: "character-sakurada-aoi",
    category: "character",
    excerpt: "樱田葵是《母乳战记》中人气最高的角色之一。她白天是温柔的保育员，夜晚则化身为守护孩子们的战士，而她的力量源泉——正是母爱。",
    content: `
      <h2>基本信息</h2>
      <p><strong>姓名：</strong>樱田葵（Sakurada Aoi）</p>
      <p><strong>年龄：</strong>28岁</p>
      <p><strong>职业：</strong>保育员 / 夜间守护者</p>
      <p><strong>能力：</strong>"母爱结界"——以母乳中的生命能量构建的防御屏障</p>

      <h2>角色背景</h2>
      <p>樱田葵出生在一个普通的日本家庭，从小就特别喜欢照顾小孩子。高中毕业后，她进入保育专业学校学习，并成为了一名优秀的保育员。在生下自己的女儿小樱后，她发现自己拥有了特殊的能力。</p>
      <p>每当她给女儿哺乳时，身体周围会散发出温暖的金色光芒。这种光芒不仅可以安抚哭闹的孩子，还能形成一层看不见的保护罩，抵御任何伤害。</p>

      <h2>战斗风格</h2>
      <p>樱田葵的战斗方式与其他战士截然不同。她从不主动攻击，而是用"母爱结界"保护无辜的人们。她的结界越强大，说明她对孩子的爱越深沉。</p>
      <p>在战斗中，她总是说："我不是在战斗，我是在守护。"这句话成为了《母乳战记》系列最经典的台词之一。</p>

      <h2>角色意义</h2>
      <p>樱田葵代表了现代母亲的多元身份——既是温柔的家庭照顾者，也是社会中不可忽视的力量。她的角色设定打破了"母亲就是柔弱"的刻板印象，展现了母爱的坚韧与强大。</p>
      <p>许多读者表示，樱田葵让她们重新认识了自己作为母亲的价值，也让年轻一代对母乳哺育有了更积极的看法。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20anime%20style%20character%20illustration%20of%20a%20gentle%20Japanese%20woman%20with%20long%20pink%20hair%20wearing%20a%20soft%20apron%2C%20warm%20golden%20glow%20around%20her%2C%20holding%20a%20baby%20protectively%2C%20soft%20pastel%20color%20palette%2C%20healing%20atmosphere%2C%20clean%20cream%20background&width=800&height=450&seq=article-aoi-character&orientation=landscape",
    author: "月光笔触",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20crescent%20moon%20with%20a%20gentle%20feminine%20smile%2C%20soft%20pink%20and%20cream%20tones%2C%20simple%20flat%20design&width=100&height=100&seq=avatar-moonlight&orientation=squarish",
    date: "2026-07-28",
    readTime: "6分钟",
    tags: ["角色设定", "女性力量", "守护", "母乳战记"],
    featured: true,
  },
  {
    id: 3,
    title: "同人精选：《鬼灭之刃》蝴蝶忍——虫柱的温柔一面",
    slug: "fanart-kimetsu-shinobu",
    category: "fanart",
    excerpt: "粉丝笔下的蝴蝶忍不再只是冷酷的虫柱，而是一位用温柔守护孩子们的大姐姐。她用自己的方式，传递着姐姐留下的爱与关怀。",
    content: `
      <h2>同人创作背景</h2>
      <p>蝴蝶忍是《鬼灭之刃》中备受欢迎的角色。在原作中，她失去了最爱的姐姐，将这份温柔隐藏在冷酷的外表之下。而在同人圈中，粉丝们常常用画笔描绘她内心的温柔——尤其是她对孩子们的关爱。</p>

      <h2>作品赏析</h2>
      <p>这组同人作品中，画师"蝴蝶之梦"描绘了蝴蝶忍在蝶屋照顾受伤的孩子们，给他们喂药、讲故事、唱歌的温暖场景。特别值得一提的是，其中一幅描绘了蝴蝶忍正在用母乳喂养一位失去母亲的新生儿的画面——这是对原作中她失去姐姐后坚强承担起照顾责任的深刻致敬。</p>

      <h2>社区反响</h2>
      <p>这组作品在奶妈动漫社区引发了热烈讨论。许多读者表示，这些画面让他们看到了蝴蝶忍角色更深层的温柔与坚强。母乳哺育在这里不仅是一种喂养方式，更象征着生命与爱的传递。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20warm%20anime%20fanart%20style%20illustration%20of%20a%20purple%20haired%20female%20character%20with%20butterfly%20hairpin%20gently%20caring%20for%20children%20in%20a%20traditional%20Japanese%20room%2C%20soft%20sunlight%20streaming%20through%20windows%2C%20healing%20vibe%2C%20pastel%20colors%20on%20cream%20background&width=800&height=450&seq=article-shinobu-fanart&orientation=landscape",
    author: "蝴蝶之梦",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20purple%20butterfly%20with%20soft%20elegant%20wings%2C%20minimalist%20flat%20design%20on%20light%20background&width=100&height=100&seq=avatar-butterfly&orientation=squarish",
    date: "2026-07-25",
    readTime: "5分钟",
    tags: ["同人创作", "鬼灭之刃", "蝴蝶忍", "温情"],
    featured: false,
  },
  {
    id: 4,
    title: "母乳哺育与动漫：那些温暖人心的育儿场景",
    slug: "breastfeeding-anime-scenes",
    category: "recommend",
    excerpt: "动漫中有许多描绘母乳哺育的温情场景，它们或温馨、或感人、或充满力量。让我们一起来回顾这些打动人心的动画时刻。",
    content: `
      <h2>动漫中的哺育场景</h2>
      <p>在日本动漫中，母乳哺育虽然不是最常见的主题，但每当出现时，往往伴随着极其动人的情感表达。这些场景通常出现在战争、灾难或家族传承等宏大叙事中，象征着生命的延续与希望的传递。</p>

      <h2>《狼与香辛料》</h2>
      <p>赫萝作为丰收之神，她对生命的珍视体现在每一个微小的细节中。虽然原作没有直接的哺育场景，但赫萝对孩子的温柔态度和对生命的尊重，让她成为许多母亲观众的共鸣对象。</p>

      <h2>《CLANNAD》</h2>
      <p>古河渚在生下女儿汐后身体极度虚弱，但她依然坚持母乳喂养。这一幕让无数观众泪目——母亲的坚持与爱，超越了身体的极限。</p>

      <h2>《来自深渊》</h2>
      <p>虽然是一部黑暗奇幻作品，但其中关于母爱的描绘令人动容。莉可的母亲莱莎，虽然身在深渊底层，但那份跨越深渊的母爱，如同母乳一般滋养着莉可成长的每一天。</p>

      <h2>推荐理由</h2>
      <p>这些作品中的哺育场景，都超越了单纯的生理行为，成为了母爱、生命与希望的象征。对于动漫爱好者和年轻父母来说，它们既是情感共鸣的源泉，也是了解母乳哺育文化的窗口。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20warm%20and%20nostalgic%20anime%20collage%20style%20illustration%20showing%20various%20gentle%20mother%20and%20child%20moments%20from%20different%20anime%20styles%2C%20soft%20watercolor%20effect%2C%20warm%20sunset%20tones%2C%20healing%20atmosphere%20on%20cream%20background&width=800&height=450&seq=article-anime-scenes&orientation=landscape",
    author: "动漫妈妈",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20mother%20and%20child%20silhouette%20in%20warm%20golden%20circle%2C%20simple%20flat%20design&width=100&height=100&seq=avatar-anime-mom&orientation=squarish",
    date: "2026-07-20",
    readTime: "7分钟",
    tags: ["动漫推荐", "温情场景", "育儿", "CLANNAD"],
    featured: true,
  },
  {
    id: 5,
    title: "科普漫画：母乳喂养的十大误区",
    slug: "breastfeeding-myths-comic",
    category: "knowledge",
    excerpt: "以可爱的动漫角色和轻松幽默的漫画形式，破除关于母乳喂养的十大常见误区，让新手妈妈们更有信心地踏上哺乳之旅。",
    content: `
      <h2>误区一：母乳不够营养？</h2>
      <p>很多人认为母乳看起来"稀"，不如配方奶粉营养。实际上，母乳含有超过200种已知的有益成分，包括抗体、酶、激素和生长因子，是任何配方奶粉都无法完全复制的。</p>
      <p>在漫画中，我们设计了"营养小精灵"这个角色，她住在妈妈的乳房里，每天都在精心调配最适合宝宝的"魔法配方"。</p>

      <h2>误区二：哺乳会让胸部变形？</h2>
      <p>怀孕本身就会导致乳房变化，而非哺乳所致。实际上，哺乳有助于子宫收缩恢复，对产后恢复非常有益。</p>
      <p>我们的漫画角色"守护天使"会告诉大家：你的身体在做一件伟大的事情，它比你想象的更坚强、更美丽。</p>

      <h2>误区三：生病不能喂奶？</h2>
      <p>大多数情况下，妈妈生病时更应该继续哺乳。因为妈妈体内产生的抗体会通过母乳传递给宝宝，帮助宝宝抵抗疾病。</p>

      <h2>漫画特色</h2>
      <p>本系列漫画采用Q版可爱的画风，将复杂的科学知识转化为简单易懂的故事。每个误区都有对应的"科普小精灵"来解答，让学习变得轻松有趣。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20cute%20and%20funny%20educational%20anime%20comic%20style%20illustration%20with%20chibi%20characters%20explaining%20breastfeeding%20facts%2C%20speech%20bubbles%2C%20soft%20pastel%20pink%20and%20cream%20colors%2C%20clean%20and%20playful%20design&width=800&height=450&seq=article-myths-comic&orientation=landscape",
    author: "小暖医生",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20doctor%20avatar%20with%20stethoscope%20and%20warm%20smile%2C%20simple%20flat%20design%20on%20light%20cream%20background&width=100&height=100&seq=avatar-warm-doctor&orientation=squarish",
    date: "2026-07-15",
    readTime: "10分钟",
    tags: ["育儿科普", "母乳喂养", "漫画", "新手妈妈"],
    featured: false,
  },
  {
    id: 6,
    title: "每日一暖：牛奶妈妈与小羊羔的约定",
    slug: "daily-warmth-milk-mom",
    category: "story",
    excerpt: `在一个遥远的山谷里，住着一位被称为「牛奶妈妈」的温柔女性。她收养了所有失去母亲的小动物，用爱和母乳哺育它们长大。`,
    content: `
      <h2>山谷里的传说</h2>
      <p>在青岚山谷的深处，有一间开满野花的小木屋。木屋里住着一位被小动物们称为"牛奶妈妈"的女性——晴子。</p>
      <p>晴子曾经是一位护士，在一次地震救援中，她收养了一只失去母亲的小羊羔。看着瑟瑟发抖的小生命，晴子做了一个不同寻常的决定——她用自己的母乳喂养这只小羊羔。</p>

      <h2>动物们的守护</h2>
      <p>消息在山谷中传开了。越来越多失去母亲的小动物被带到晴子的小木屋前。小兔子、小鹿、小狐狸……晴子来者不拒，用她温暖的怀抱和无尽的爱滋养着每一个小生命。</p>
      <p>而作为回报，这些小动物们长大后，成为了山谷的守护者。它们保护着晴子的小木屋，也保护着每一个来到这里的弱小生命。</p>

      <h2>小羊羔的约定</h2>
      <p>那只最早被晴子救下的小羊羔已经长大了，成为了一只威武的领头羊。每天清晨，它都会叼来最新鲜的青草，放在晴子的门前。</p>
      <p>"妈妈，谢谢你给了我第二次生命。"它在心中默默说道。</p>
      <p>晴子轻抚着它的头，微笑着说："我们之间的约定，永远不变。"</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20warm%20and%20dreamy%20anime%20illustration%20of%20a%20gentle%20woman%20in%20a%20flower%20garden%20with%20various%20cute%20baby%20animals%20around%20her%2C%20soft%20sunlight%2C%20pastel%20pink%20and%20green%20colors%2C%20healing%20storybook%20style%20on%20cream%20background&width=800&height=450&seq=article-milk-mom-story&orientation=landscape",
    author: "晴子",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20lamb%20with%20a%20flower%20crown%2C%20simple%20flat%20design%20on%20light%20cream%20background&width=100&height=100&seq=avatar-haruko&orientation=squarish",
    date: "2026-07-10",
    readTime: "5分钟",
    tags: ["治愈故事", "动物", "母爱", "温暖"],
    featured: false,
  },
  {
    id: 7,
    title: `同人企划：百名画师笔下的「哺乳中的妈妈」`,
    slug: "fanart-project-breastfeeding-moms",
    category: "fanart",
    excerpt: `百位同人画师联合创作——以不同风格、不同视角描绘哺乳妈妈的美好瞬间，展现母乳哺育的多样之美。`,
    content: `
      <h2>企划缘起</h2>
      <p>在一次社区讨论中，有画师提出："为什么动漫中很少有正面的哺乳场景？"这个问题引发了广泛共鸣。于是，奶妈动漫社区发起了"百名画师·哺乳之美"联合创作企划。</p>
      <p>一百位画师，一百种风格，一百个关于哺乳的温暖故事。从古风到赛博朋克，从写实到Q版，每一幅作品都是对母爱的一次独特诠释。</p>

      <h2>精彩作品巡礼</h2>
      <p>画师"水墨妈妈"用中国传统水墨风格，描绘了一位在竹林中哺乳的古代仕女，画面宁静致远，令人心旷神怡。</p>
      <p>画师"未来之光"则用赛博朋克风格，创作了一位在未来都市中哺乳的机械义肢母亲，探讨科技与人性的交融。</p>
      <p>画师"童话镇"的Q版作品，将不同动物妈妈哺乳的场景画成了童话绘本，深受年轻妈妈和孩子们的喜爱。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20art%20gallery%20style%20anime%20illustration%20showing%20multiple%20art%20pieces%20of%20mothers%20and%20babies%20in%20different%20art%20styles%20displayed%20on%20a%20warm%20lit%20wall%2C%20soft%20gallery%20lighting%2C%20cream%20and%20gold%20tones&width=800&height=450&seq=article-fanart-project&orientation=landscape",
    author: "奶妈动漫编辑部",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20notebook%20and%20pen%20with%20hearts%2C%20simple%20flat%20design%20on%20light%20background&width=100&height=100&seq=avatar-editor&orientation=squarish",
    date: "2026-07-05",
    readTime: "6分钟",
    tags: ["同人创作", "联合企划", "艺术", "母爱"],
    featured: true,
  },
  {
    id: 8,
    title: "《母乳战记》序章：觉醒吧，母爱的力量！",
    slug: "breast-milk-war-chronicles",
    category: "original",
    excerpt: "奶妈动漫重磅原创连载漫画《母乳战记》正式启动！当世界陷入危机，母亲们将用最原始也最强大的力量——母爱，守护这个世界的未来。",
    content: `
      <h2>序章：黑暗降临</h2>
      <p>公元2045年，一场神秘的"母婴分离症"在全球蔓延。感染此症的母亲会逐渐失去对孩子的爱，新生儿因为缺乏母乳喂养而变得虚弱。人类文明面临前所未有的危机。</p>
      <p>然而，有一群母亲展现了惊人的免疫能力。她们的母乳中蕴含着特殊的抗体，不仅能够抵抗"分离症"，还能让喝下母乳的人获得特殊的力量——这就是"母爱之力"。</p>

      <h2>战士集结</h2>
      <p>全世界最强大的"母爱战士"被召集到一个秘密基地。她们来自不同的国家、不同的文化背景，但有着共同的身份——母亲。</p>
      <p>樱田葵（日本）、玛丽亚·桑切斯（墨西哥）、艾莎·穆巴拉克（埃及）、王雪莲（中国）……她们将成为人类对抗"分离症"的最后希望。</p>

      <h2>连载计划</h2>
      <p>《母乳战记》将于每周五在奶妈动漫平台独家更新。故事将围绕五位母爱战士的成长与战斗展开，探索母爱、牺牲、团结与希望的永恒主题。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=An%20epic%20anime%20style%20illustration%20of%20five%20powerful%20mother%20warriors%20from%20different%20cultures%20standing%20together%20with%20golden%20auras%2C%20dramatic%20but%20warm%20lighting%2C%20soft%20pastel%20hero%20style%2C%20cream%20background&width=800&height=450&seq=article-war-chronicles&orientation=landscape",
    author: "奶妈动漫创作组",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20five%20stars%20forming%20a%20heart%20shape%2C%20simple%20flat%20design%20on%20light%20cream%20background&width=100&height=100&seq=avatar-crew&orientation=squarish",
    date: "2026-06-30",
    readTime: "7分钟",
    tags: ["原创漫画", "连载", "母乳战记", "热血"],
    featured: true,
  },
  {
    id: 9,
    title: "角色设定集：王雪莲——东方母爱战士",
    slug: "character-wang-xuelian",
    category: "character",
    excerpt: `来自中国的母爱战士王雪莲，以传统中医智慧和太极功法为基础，开发出独特的「气韵哺育术」，将母乳与真气融合，创造出最纯粹的治愈能量。`,
    content: `
      <h2>基本信息</h2>
      <p><strong>姓名：</strong>王雪莲</p>
      <p><strong>年龄：</strong>32岁</p>
      <p><strong>国籍：</strong>中国</p>
      <p><strong>能力：</strong>"气韵哺育术"——将太极真气融入母乳，创造全能治愈能量</p>

      <h2>角色背景</h2>
      <p>王雪莲出身于中医世家，自幼学习太极和中医理论。成为母亲后，她发现将太极的内功心法与哺乳结合，可以让母乳中的治愈能力成倍增长。</p>
      <p>她常说："天地万物的能量，最终都归于一个字——爱。"她的战斗方式极具东方美学，每一个动作都如同太极拳法，优雅而有力。</p>

      <h2>设计理念</h2>
      <p>王雪莲的角色设计融合了大量中国传统元素：旗袍式战衣、太极图纹饰、莲花头饰。她的代表色是中国红与金色，象征着生命、热情与高贵。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20anime%20warrior%20woman%20in%20traditional%20Chinese%20style%20outfit%20with%20flowing%20red%20silk%20ribbons%2C%20elegant%20tai%20chi%20pose%2C%20golden%20energy%20surrounding%20her%2C%20soft%20ethereal%20lighting%2C%20cream%20background&width=800&height=450&seq=article-wang-xuelian&orientation=landscape",
    author: "东方画师联盟",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20traditional%20Chinese%20fan%20with%20lotus%20pattern%2C%20soft%20red%20and%20cream%20tones&width=100&height=100&seq=avatar-eastern&orientation=squarish",
    date: "2026-06-25",
    readTime: "5分钟",
    tags: ["角色设定", "东方元素", "太极", "母乳战记"],
    featured: false,
  },
  {
    id: 10,
    title: "新手妈妈必看：动漫中的育儿哲学",
    slug: "anime-parenting-philosophy",
    category: "knowledge",
    excerpt: "从《千与千寻》到《你的名字》，这些经典动漫中蕴含的育儿智慧，比任何教科书都更能触动新手妈妈的心。",
    content: `
      <h2>《千与千寻》：放手与信任</h2>
      <p>宫崎骏的经典之作中，千寻的父母因为贪婪变成了猪，而千寻必须独自面对奇幻世界的挑战。这看似与育儿无关的情节，却蕴含着深刻的育儿哲学——有时候，我们需要让孩子自己去面对困难。</p>
      <p>就像母乳喂养一样，我们给予孩子最好的营养，但最终他们要自己去成长、去探索这个世界。</p>

      <h2>《龙猫》：大自然是最好的老师</h2>
      <p>小月和小梅在乡间遇到了龙猫，这段奇妙的经历让她们学会了勇敢、乐观和关爱他人。对于现代都市中的妈妈们来说，这部作品提醒我们——让孩子接触大自然、保持好奇心，比任何早教班都重要。</p>

      <h2>《你的名字》：连接与传承</h2>
      <p>新海诚笔下跨越时空的爱情故事，其实也暗含着生命传承的主题。三叶的绳结——"产灵"——象征着人与人之间的连接，也象征着母乳中传递的生命能量。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20warm%20nostalgic%20anime%20illustration%20collage%20featuring%20iconic%20Studio%20Ghibli%20style%20scenes%20of%20nature%20and%20family%2C%20soft%20watercolor%20effect%2C%20gentle%20green%20and%20cream%20tones&width=800&height=450&seq=article-parenting-philosophy&orientation=landscape",
    author: "二次元妈妈",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20soot%20sprite%20from%20ghibli%20style%20holding%20a%20small%20heart%2C%20minimalist%20flat%20design&width=100&height=100&seq=avatar-otaku-mom&orientation=squarish",
    date: "2026-06-20",
    readTime: "8分钟",
    tags: ["育儿科普", "宫崎骏", "动漫哲学", "新海诚"],
    featured: false,
  },
  {
    id: 11,
    title: "温暖绘本：《妈妈的怀抱是全世界》",
    slug: "picture-book-moms-embrace",
    category: "story",
    excerpt: "一部温暖人心的原创绘本故事。在小宝宝的眼中，妈妈的怀抱就是全世界——那里有最香甜的乳汁、最安心的心跳、最温柔的目光。",
    content: `
      <h2>第一页：初遇</h2>
      <p>我来到这个世界的第一天，就闻到了一种特别的味道。暖暖的、甜甜的，比花香更迷人，比蜜糖更醇厚。</p>
      <p>那是妈妈的味道。是母乳的味道。是家的味道。</p>

      <h2>第二页：守护</h2>
      <p>每当夜晚来临，周围变得黑暗而陌生。但只要我贴近妈妈的怀抱，听到那熟悉的心跳声，所有的恐惧都会消失。</p>
      <p>砰、砰、砰——那是全世界最动听的摇篮曲。</p>

      <h2>第三页：成长</h2>
      <p>在妈妈的怀抱里，我从一个小小的婴儿，慢慢长成了会爬、会走、会跑的孩子。妈妈的乳汁像神奇的泉水，滋养着我每一天的成长。</p>

      <h2>第四页：永远</h2>
      <p>也许有一天，我长大到不需要再喝妈妈的乳汁了。但我永远记得，在妈妈怀里的那段温暖时光——那里，就是我的全世界。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20heartwarming%20children%20book%20style%20anime%20illustration%20of%20a%20mother%20gently%20holding%20her%20sleeping%20baby%20in%20her%20arms%2C%20soft%20glowing%20light%20around%20them%2C%20dreamy%20stars%20and%20flowers%2C%20pastel%20pink%20and%20cream%20palette&width=800&height=450&seq=article-picture-book&orientation=landscape",
    author: "暖阳绘本馆",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20an%20open%20book%20with%20a%20small%20sun%20rising%20from%20it%2C%20simple%20flat%20design&width=100&height=100&seq=avatar-picture-book&orientation=squarish",
    date: "2026-06-15",
    readTime: "4分钟",
    tags: ["治愈故事", "绘本", "母爱", "亲子"],
    featured: false,
  },
  {
    id: 12,
    title: "2026夏季新番推荐：五部值得期待的温情动漫",
    slug: "2026-summer-anime-recommend",
    category: "recommend",
    excerpt: "新番季节又到了！为大家精选了五部充满温情与治愈元素的夏季新番，其中不乏涉及亲子关系和成长主题的佳作。",
    content: `
      <h2>1. 《星之摇篮》</h2>
      <p>讲述了一位太空殖民地的保育员和她照顾的孩子们的故事。在无重力的太空中，母爱如何超越物理的限制，成为孩子们最坚实的依靠。</p>

      <h2>2. 《小森林物语》</h2>
      <p>一位年轻母亲带着孩子搬到乡间，在自然中寻找育儿真谛的治愈系日常番。每一集都有精美的食物画面和温暖的亲子互动。</p>

      <h2>3. 《海洋之子》</h2>
      <p>以海洋保护为主题，主角是一位研究海洋生物的妈妈科学家。她带着孩子一起探索海洋的奥秘，展现了知识传递与亲子陪伴的美好。</p>

      <h2>4. 《花与月》</h2>
      <p>古风题材，讲述一位宫廷奶妈与公主之间的感人故事。精美的画面和深刻的情感刻画，让这部作品成为本季最受期待的新番之一。</p>

      <h2>5. 《明日之歌》</h2>
      <p>近未来设定，一位单亲妈妈在AI时代的育儿故事。探讨科技与传统育儿方式的平衡，引人深思。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=A%20colorful%20anime%20style%20illustration%20showing%20a%20summer%20anime%20season%20collage%20with%20various%20warm%20healing%20style%20anime%20characters%2C%20bright%20summer%20colors%2C%20soft%20sunlight%2C%20cream%20background&width=800&height=450&seq=article-summer-anime&orientation=landscape",
    author: "新番猎人",
    authorAvatar: "https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20avatar%20of%20a%20cat%20wearing%20headphones%2C%20minimalist%20flat%20design%20on%20light%20cream%20background&width=100&height=100&seq=avatar-anime-hunter&orientation=squarish",
    date: "2026-06-10",
    readTime: "6分钟",
    tags: ["动漫推荐", "新番", "夏季", "治愈"],
    featured: false,
  },
];

export const featuredArticles = articles.filter((a) => a.featured);

export const aboutInfo = {
  brand: {
    name: "奶妈动漫",
    slogan: "母乳哺育与动漫文化融合平台",
    intro:
      "奶妈动漫创立于2024年，是国内首家专注于母乳哺育题材与动漫文化交汇的内容平台。我们汇聚了来自全国的优秀创作者，用动漫这一年轻人喜爱的艺术形式，传递母乳哺育的美好与力量。",
    story:
      "创始团队由一群热爱动漫的年轻妈妈组成。在经历了生育和哺乳的旅程后，她们发现市面上很少有作品真正展现母乳哺育的温暖与力量。于是，奶妈动漫应运而生——我们希望用画笔、用故事、用角色，让更多人看到母乳哺育背后的爱与美。",
    values: [
      { title: "温暖治愈", desc: "每一篇作品都传递着爱与温暖，让读者感受到母乳哺育的美好" },
      { title: "科学严谨", desc: "育儿科普内容由专业人士审核，确保信息准确可靠" },
      { title: "创意无限", desc: "鼓励原创与同人创作，为动漫爱好者提供自由创作的平台" },
      { title: "包容多元", desc: "欢迎不同风格、不同视角的创作，展现母乳哺育的多样之美" },
    ],
  },
  stats: [
    { label: "原创作品", value: "200+" },
    { label: "活跃画师", value: "150+" },
    { label: "社区成员", value: "50,000+" },
    { label: "科普文章", value: "80+" },
  ],
  team: [
    { name: "暖阳", role: "创始人 & 主编", desc: "两个孩子的妈妈，前动漫杂志编辑" },
    { name: "月光笔触", role: "首席画师", desc: "十年动漫创作经验，擅长温情风格" },
    { name: "小暖医生", role: "医学顾问", desc: "三甲医院儿科医生，国际认证泌乳顾问" },
    { name: "二次元妈妈", role: "内容运营", desc: "资深动漫爱好者，育儿博主" },
  ],
  contact: {
    email: "hello@naimadongman.com",
    weibo: "@奶妈动漫官方",
    wechat: "NaiMaDongMan",
    address: "浙江省杭州市西湖区动漫产业园B座302室",
  },
};